import React from 'react';
import { useNavigate } from 'react-router-dom'; // if using React Router v6
import { useLocation } from 'react-router-dom';
function CheckoutComponent() {
  const location = useLocation();
  const { selectedSlot, selectedDate, doctor } = location.state || {};
  
  console.log('checkout component')
  console.log('selected slot checkout component',selectedSlot)
  console.log('selected date checkout component',selectedDate)

  console.log('doctor',doctor)
  const navigate = useNavigate(); // if using React Router v6

  const handlePayment = () => {
    // Here you would typically open a Stripe Checkout or similar
    // For now, we'll just navigate to a placeholder payment page
   // navigate('/payment');
  };

  if (!selectedSlot || !doctor) {
    // Handle the case where the slot or doctor data is not available
    return <div>Loading...</div>;
  }

  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-md-6">
          <div className="card">
            <div className="card-body">
              <h2 className="card-title">Appointment Details</h2>
              <p className="card-text">Doctor: {doctor.name}</p>
              <p className="card-text">Date: {selectedDate.toLocaleDateString('en-IN', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}</p>
              <p className="card-text">Time: {selectedSlot}</p>
              <p className="card-text">Consultation Fee: {doctor.consultation_fee}</p>
              <p className="card-text">Booking Fee: {doctor.booking_fee}</p>
              <button className="btn btn-primary w-100" onClick={handlePayment}>Proceed to Payment</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CheckoutComponent;
